import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import imgUrl from '@/assets/others/index/bg.gif';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

import { queryCurveAnalysis, queryWastSiteStand, queryWastDateList } from '@/api/api';
var amapManager = new VueAMap.AMapManager(); // let amas = new VueAMap.RangingTool()
// 预警组件

import warn from '@/components/border/warn';
import border from '@/components/border/borderType'; // 达标率

import ball from '@/components/env-bigData/ball';
import fileTable from '@/components/border/fileTable'; // 主要污染物

import pillar from '@/components/env-bigData/pillar'; //水质分布

import ratio from '@/components/env-bigData/ratio'; // 空气质量指数表盘图

import instrument from '@/components/env-bigData/instrument'; // 空气质量指数进度图

import barType from '@/components/env-bigData/barType'; // 空气质量天数表盘图

import plate from '@/components/env-bigData/plate'; // 空气质量天数双表盘图

import doublePlate from '@/components/env-bigData/doublePlate';
import mapTag from "../com/mapTag";
import mapLegend from "../com/mapLegend.vue";
import { queryRealtime, mainRealtime, querySiteList, queryStandardTreeList, queryWaterStand, queryRankSkylist, querySkyStandBySite, queryRealWaterDateList, queryWastWaterDateList, queryAreaInfo, queryPipeSystem, queryManholeCover, querySiteBySt } from '@/api/api';
import dial from '@/components/env-bigData/watch';
import { commonRender } from '@/mixins/commonRender';
import Earth from "../../../components/Map/earth";
var inter;
export default {
  mixins: [commonRender],
  components: {
    Earth: Earth,
    border: border,
    dial: dial,
    ratio: ratio,
    warn: warn,
    ball: ball,
    pillar: pillar,
    instrument: instrument,
    barType: barType,
    plate: plate,
    doublePlate: doublePlate,
    fileTable: fileTable,
    mapTag: mapTag,
    mapLegend: mapLegend
  },
  data: function data() {
    return {
      district: null,
      citys: [],
      ratioWidth: '',
      ratioHeight: '',
      ballWidth: '',
      ballHeight: '',
      columnWidth: '',
      columnHeight: '',
      fileState: true,
      warnState: true,
      reportState: true,
      selectIndex: '',
      firstPollution: {},
      standLabel: '',
      standText: '',
      showState: true,
      distributeName: '水质分布',
      reportName: '水质日报',
      // selectIndex: 21,
      standState: false,
      dateLists: [],
      windows: [],
      window: '',
      standardList: [],
      markerList: [],
      waterWarnList: [],
      // 日报数据
      dateList: [],
      // 水质分布数据
      standardMap: [],
      // 达标率
      compliant: 1,
      siteDetail: {},
      netSelectindex: 0,
      roadSelectindex: 0,
      mapControlindex: 0,
      time: [],
      labelData: [],
      pollutionData: [],
      amapManager: amapManager,
      center: [118.047928, 24.613341],
      zoom: 12,
      siteWarnList: [],
      mapSelectindex: 0,
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      // tabList: [{
      // 		name: '水质',
      // 		st: '21',
      // 		iconfont: 'icon-shuizhijiance',
      // 	},
      // 	{
      // 		name: '空气',
      // 		st: '22',
      // 		iconfont: 'icon-app_icons--',
      // 	},
      // ],
      selectType: '21',
      defaultValue: 1,
      pipeList: [],
      wellList: [],
      wellImg: require('@/assets/others/well.png'),
      pipeOffset: new AMap.Pixel(-20, -25),
      riverPath: [],
      mouseoverId: '',
      highlightLines: {},
      highlightLinesTooltip: {
        x: 0,
        y: 0,
        content: '这是线条描述'
      },
      showCustomTooltip: false,
      timeSite: null
    };
  },
  created: function created() {
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];

    if (window.localStorage.getItem('areaNameList') && window.localStorage.getItem('areaNameList') != 'null' && window.localStorage.getItem('areaNameList') != 'undefined') {
      this.citys = JSON.parse(window.localStorage.getItem('areaNameList'));
    } //

  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resetWidth);
  },
  watch: {
    markerList: function markerList(val) {
      if (val) {
        var that = this;
        that.riverPath = [];
        val.forEach(function (item) {
          var pointList = item.mapRegion ? item.mapRegion.split(':') : [];
          var line = pointList.map(function (v) {
            return v.split('-').map(function (item1) {
              return item1.split(',');
            });
          });
          that.riverPath.push({
            path: line[0],
            name: item.name,
            id: item.id,
            color: item.currentStandard ? item.currentStandard.color : '#55aaff',
            events: {
              mouseover: function mouseover(e) {
                that.mouseoverId = item.id;
                that.highlightLinesTooltip = {
                  x: e.pixel.x - 40,
                  y: e.pixel.y - 40,
                  content: item.name
                };
                that.showCustomTooltip = true;
                that.timeSiteShow(item);
              },
              mouseout: function mouseout() {
                that.showCustomTooltip = false;
                that.mouseoverId = '';
                clearInterval(that.timeSite);
              }
            }
          });
        });
      }
    },
    mouseoverId: function mouseoverId(val) {
      var _this = this;

      if (val) {
        this.riverPath.forEach(function (item) {
          if (item.id == val) {
            _this.highlightLines = item;
          }
        });
      } else {
        this.highlightLines = {};
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      // this.selectIndex = this.tabList[0].st
      setTimeout(function () {
        _this2.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
        var map = amapManager.getMap();

        _this2.setMapTile(map);
      }, 1000);
    }); // inter = setInterval(this.scroll, 1000)
    //自适应

    this.resetWidth();
    window.addEventListener('resize', this.resetWidth, false);
    this.getPipeSystem();
    this.getManholeCover();
  },
  methods: {
    timeSiteShow: function timeSiteShow(item) {
      this.timeSite = setInterval(function () {
        item.show = !item.show;
      }, 1000);
    },
    // 获取所有管网数据
    getPipeSystem: function getPipeSystem() {
      var that = this;
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(function (item) {
            var pointList = item.coordinate.split(':');
            var lines = pointList.map(function (v) {
              return v.split('-').map(function (item) {
                return item.split(',');
              });
            });
            item.lines = lines;
            return item;
          });
        }
      });
    },
    // 获取所有窨井盖数据
    getManholeCover: function getManholeCover() {
      var _this3 = this;

      var that = this;
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.wellList = res.result.records.map(function (item) {
            return {
              id: item.id,
              position: item.coordinate.split(','),
              content: "<img style=\"width: 30px;height: 30px;\" src=\"".concat(_this3.wellImg, "\" />"),
              events: function events() {// 点击窨井盖
              }
            };
          });
        }
      });
    },
    drawBounds: function drawBounds() {
      var map = amapManager.getMap();
      var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
      areaRoot.forEach(function (item) {
        queryAreaInfo(item).then(function (res) {
          if (res.success) {
            var features = [];

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
              var inline = features.map(function (area) {
                return area.map(function (info) {
                  return new AMap.LngLat(info[0], info[1], true);
                });
              });
              var pathArray = [outer];
              pathArray.push.apply(pathArray, inline);
              var polygon = new AMap.Polygon({
                // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                pathL: pathArray,
                //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                strokeColor: 'rgb(20,164,173)',
                strokeWeight: 4,
                //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: 'rgba(99,99,99)',
                //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: 0.3,
                zIndex: 99999999
              });
              polygon.setPath(pathArray);
              map.add(polygon); // features.forEach(area=>{
              //   var polygon = new AMap.Polygon({
              //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //     path: area,
              //     strokeColor: "#FF33FF",
              //     strokeWeight: 3,
              //     strokeOpacity: 0.5,
              //     fillOpacity: 0.3,
              //     fillColor: "#1791fc",
              //     zIndex: 99999999,
              //   });
              //   map.add(polygon);
              // })
            }
          }
        });
      });
    },
    resetWidth: function resetWidth() {
      this.$refs.ratioBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.ratioBorder.height = document.documentElement.clientHeight * 0.275;
      this.$refs.ballBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.ballBorder.height = document.documentElement.clientHeight * 0.275;
      this.$refs.columnBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.columnBorder.height = document.documentElement.clientHeight * 0.275;
      this.$refs.warnBorder.width = document.documentElement.clientWidth * 0.28;
      this.$refs.warnBorder.height = document.documentElement.clientHeight * 0.5;
      this.$refs.warnBorder1.width = document.documentElement.clientWidth * 0.28;
      this.$refs.warnBorder1.height = document.documentElement.clientHeight * 0.34;
      this.ratioWidth = document.documentElement.clientWidth * 0.24 + 'px';
      this.ratioHeight = document.documentElement.clientHeight * 0.25 + 'px';
      this.ballWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.ballHeight = document.documentElement.clientHeight * 0.3 + 'px';
      this.columnWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.columnHeight = document.documentElement.clientHeight * 0.24 + 'px';
    },
    changeList: function changeList(val, sortData) {
      console.log(val, sortData);

      switch (sortData) {
        case 'standard':
          // 正序
          if (val) {
            var compare = function compare(property) {
              return function (a, b) {
                var value1 = a.attrs.currentStandard && a.attrs.currentStandard[property] != undefined ? a.attrs.currentStandard[property] : '10000';
                var value2 = b.attrs.currentStandard && b.attrs.currentStandard[property] != undefined ? b.attrs.currentStandard[property] : '10000';
                return value1 - value2;
              };
            };

            this.dateList.sort(compare('grade'));
          } else {
            var _compare = function _compare(property) {
              return function (a, b) {
                var value1 = a.attrs.currentStandard && a.attrs.currentStandard[property] != undefined ? a.attrs.currentStandard[property] : '10000';
                var value2 = b.attrs.currentStandard && b.attrs.currentStandard[property] != undefined ? b.attrs.currentStandard[property] : '10000';
                return value1 - value2;
              };
            };

            this.dateList.sort(_compare('grade')).reverse();
          }

          break;

        case 'time':
          // 正序
          if (val) {
            this.dateList.sort(function (a, b) {
              return new Date(a.dataTime.replace(/-/g, '/')).getTime() - new Date(b.dataTime.replace(/-/g, '/')).getTime();
            });
          } else {
            this.dateList.sort(function (a, b) {
              return new Date(a.dataTime.replace(/-/g, '/')).getTime() - new Date(b.dataTime.replace(/-/g, '/')).getTime();
            }).reverse();
          }

          break;
      }
    },
    close: function close() {
      this.window.visible = false;
    },
    scroll: function scroll() {
      var _this4 = this;

      setTimeout(function () {
        if (_this4.waterWarnList.length > 5) {
          _this4.waterWarnList.push(_this4.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this4.waterWarnList.shift(); //删除数组的第一个元素

        }

        if (_this4.dateList.length > 13) {
          _this4.dateList.push(_this4.dateList[0]); // 将数组的第一个元素添加到数组的


          _this4.dateList.shift(); //删除数组的第一个元素

        }

        if (_this4.dateLists.length > 7) {
          _this4.dateLists.push(_this4.dateLists[0]); // 将数组的第一个元素添加到数组的


          _this4.dateLists.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    getApi: function getApi(st, radioSelected) {
      var _this5 = this;

      this.showState = false;
      this.$nextTick(function () {
        _this5.showState = true;
        _this5.defaultValue = 1;
        setTimeout(function () {
          // this.getPolutionData(st)
          _this5.getPollution(_this5.getDay(1), st);

          _this5.getData(st);

          _this5.getDateList(st);

          _this5.getStandard(st);

          _this5.getWarn(radioSelected, st);

          _this5.drawBounds();
        }, 100);
      });
    },
    // selctTag(index, id) {
    //   //  if(this.standardList[index].data.show){
    //   if (index == this.standardList.length) {
    //     this.markerList.forEach((item, index) => {
    //       if (!item.currentStandard) {
    //         item.show = !item.show
    //       }
    //     })
    //   } else {
    //     this.standardList[index].data.show = !this.standardList[index].data.show
    //     this.markerList.forEach((item, index) => {
    //       if (item.currentStandard) {
    //         if (item.currentStandard.id == id) {
    //           item.show = !item.show
    //         }
    //       }
    //     })
    //   }
    //   //  }
    // },
    // 获取对应站点详情
    getStand: function getStand(data) {
      if (data) {
        for (var i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].data.title == data.title.replace('类', '')) {
            return i + 1;
          }
        }
      } else {
        return 0;
      }
    },
    // 获取国标数据
    getStandard: function getStandard(st) {
      var _this6 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          var arr = [];

          if (st == '21') {
            arr = [{
              title: '河',
              children: []
            }, {
              title: '湖',
              children: []
            }];
            res.result.forEach(function (item, index) {
              if (item.label == '国家标准') {
                if (item.children != null) {
                  item.children.forEach(function (item1, index1) {
                    if (item1.key == 'K1_3') {
                      arr[0].name = item1.title;
                      arr[0].children = item1.children;
                    }

                    if (item1.key == 'K1_4') {
                      arr[1].children = item1.children;
                      arr[1].name = item1.title;
                    }
                  });
                }
              }
            });
          } else if (st == '22') {
            arr = [{
              title: '气',
              children: []
            }];
            res.result.forEach(function (item, index) {
              if (item.label == '国家标准') {
                if (item.children != null) {
                  item.children.forEach(function (item1, index1) {
                    if (item1.key == 'K1_2') {
                      arr[0].children = item1.children;
                      arr[0].name = item1.title;
                    }
                  });
                }
              }
            });
          }

          console.log('arr', arr);
          arr.forEach(function (item1, index) {
            item1.children.forEach(function (item) {
              item.data.title = item.data.title.replace('类', '');
              item.data.show = true;
            });
          });
          _this6.standardList = arr;
          console.log('standardList', _this6.standardList);

          _this6.getSite(st);
        }
      });
    },
    // 获取日报数据
    getDateList: function getDateList(st) {
      var _this7 = this;

      var params = {
        size: 10000000,
        current: 1
      };

      if (st == '21') {
        queryWastDateList({
          st: st,
          column: 'data_time',
          order: 'desc'
        }).then(function (res) {
          if (res.success) {
            _this7.dateList = res.result.records;
          }
        });
      } else if (st == '22') {
        queryRankSkylist({
          st: 22
        }).then(function (res) {
          if (res.success) {
            if (res.result) {
              _this7.dateList = res.result.records;
            } else {
              _this7.dateList = [];
            }
          } else {
            _this7.dateList = [];
          }
        });
      }
    },
    // 获取一张图数据
    getData: function getData(st) {
      var _this8 = this;

      queryWastSiteStand({
        st: st
      }).then(function (res) {
        if (res.success && res.result) {
          var obj = {};
          var arr = [];

          for (var key in res.result.standardMap) {
            obj.name = key;
            obj.value = res.result.standardMap[key];
            arr.push(obj);
            obj = {};
          }

          _this8.standardMap = arr;

          _this8.$refs.ratio.initBarChart(arr);

          if (res.result.totle > 0) {
            _this8.$refs.ball.initBarChart(res.result.compliant / res.result.totle);
          } else {
            _this8.$refs.ball.initBarChart(0 .toFixed(4));
          }
        } else {
          _this8.$refs.ratio.initBarChart([]);

          _this8.$refs.ball.initBarChart(0 .toFixed(4));
        }
      });
    }
  }
};